import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkAllError } from 'src/types';
import { validationMessagesMap } from 'src/utils/messages';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/points/pricing-plans/:pointId/';

type FormSchemaValues = z.infer<typeof formSchema>;

export const formSchema = z.object({
    price_plan_id: z.coerce.number({ message: validationMessagesMap.validationErrorRequired }),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
    pointId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, pointId, ...data }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, pointId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkAllError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as UPDATE_POINT_PRICING_PLAN_RESOURCE,
    useMutationHook as useUpdatePointPricingPlan,
    formSchema as updatePointPricingPlanFormSchemaValues,
};
export type { DTO as UpdatePointPricingPlanDTO, FormSchemaValues as UpdatePointPricingPlanFormSchemaValues };
